
import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";

/**
 * 活动服务
 * @class
 * @version 1.0.0
 */
export default class EmployerActivityService extends ServiceBase
{

    /*
     * 活动服务
     * @private
     * @return EmployerActivityService
     */
    private static _instance: EmployerActivityService;

    /**
     * 活动服务
     * @static
     * @property
     * @returns EmployerActivityService
     */
    public static get instance(): EmployerActivityService
    {
        if(!this._instance)
        {
            this._instance = new EmployerActivityService();
        }
        
        return this._instance;
    }
    
    /**
     * 优惠券领取中心详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getCouponDetail(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getCouponDetail({data, loading: false});
        return response;
    }

    /**
     * 优惠券领取中心详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async couponReceive(id: any, isEncryption?: boolean): Promise<IHttpResponse>
    {

        let response = await this.apis.couponReceive({params: { id, isEncryption }});
        return response;
    }

    /**
     * 优惠券领取中心获取tabs数据
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getUseTargetKind(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getUseTargetKind({data, loading: false});
        return response;
    }

    /**
     * 我的-优惠券领取中心获取tabs数据
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async myGetUseTargetKind(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.myGetUseTargetKind({data, loading: false});
        return response;
    }

    /**
     * 客户端我的优惠券列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getCouponList(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getCouponList({data});

        return response;
    }


    /**
     * 客户端我的优惠券详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async couponMyGet(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.couponMyGet({data, loading: false});

        return response;
    }

    /**
     * 客户端获取商品可用的优惠券
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async couponSuitable(data: any, loading?: boolean): Promise<IHttpResponse>
    {

        let response = await this.apis.couponSuitable({data, loading});

        return response;
    }

    /**
     * 客户端优惠券列表数据-首页优惠券
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getCouponListPage(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getCouponListPage({data});

        return response;
    }

}
